<template>
  <div class="serviceIndex companyMagt">
    <div class="leftBax fl leftTabBag">
      <div class="searchBox">
        <el-input v-model.trim="filterText" :placeholder="$t('company.Companyname')" class="input-with-select" clearable>
          <el-button slot="append" icon="el-icon-search" />
        </el-input>
        <div class="btnBox">
          <el-button v-if="!isEdit" type="primary" icon="el-icon-edit" @click="edit" />
          <el-button v-if="isEdit" v-preventReClick type="primary" icon="el-icon-check" @click="submit" />
          <el-button v-if="isEdit" icon="el-icon-close" @click="cancel" />
        </div>
      </div>
      <el-tree ref="tree" :data="navList" node-key="idx" default-expand-all :expand-on-click-node="false" :filter-node-method="filterNode" :props="defaultProps">
        <span slot-scope="{ node, data }" class="custom-tree-node">
          <span class="labelItem">
            <img :src="companyIcon" alt="">
            <span :title="node.label">{{ node.label }}{{ node.children }}</span>
          </span>
          <div class="item" placement="bottom-end">
            <div class="moreIconBox">
              <div class="childListSize">
                <span v-if="!isEdit">{{ data.fee||20 }}</span>
                <div>
                  <el-input v-if="isEdit" v-model.trim="data.inputFee" v-number.float.positive.two size="mini" :placeholder="$t('sim.enterFee')" class="input-with-select" clearable @blur="changeFee(data.inputFee)" />
                  <span v-if="isEdit&&!data.inputFee&&!data.inputFee.length" class="warnP">{{ $t('lease.Cannotbeblanked') }}</span>
                </div>
                <span>{{ $t('sim.feeUnit') }}</span>
              </div>
            </div>
          </div>
        </span>
      </el-tree>
      <!-- <div class="footBtn">
        <el-button v-if="isEdit" type="primary" @click="submit">提交</el-button>
        <el-button v-if="isEdit" @click="cancel">取消</el-button>
      </div> -->
    </div>

  </div>
</template>

<script>
import { listCompanyServiceFee, batchUpdateCompanyServiceFee } from '@/api/sim'
export default {
  data() {
    return {
      navList: [],
      filterText: '',
      defaultProps: {
        children: 'childList',
        label: 'companyName',
        childListSize: 'childListSize'
      },
      companyIcon: require('@/assets/icon/company.png'),
      isEdit: false,
      editObj: { },
      feeArr: []
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    }
  },
  mounted() {
    setTimeout(() => {
      this.initCompanyList()// 获取左侧公司列表
    }, 100)
  },
  methods: {
    filterNode(value, data) { // 筛选过滤
      if (!value) return true
      return data.companyName.indexOf(value) !== -1
    },
    initCompanyList() { // 获取左侧公司列表--初始化
      this.isEdit = false
      listCompanyServiceFee().then(res => {
        if (res.resultCode == 1001 && res.resultModel) {
          this.navList = this.setInputFeeFn([res.resultModel])
          console.log('this.navList', this.navList)
        } else {
          this.navList = []
        }
      })
    },
    edit() {
      this.isEdit = true
    },
    setInputFeeFn(navArr) { // 设置输入框的服务费等于初始化时的服务费
      navArr.forEach(v => {
        if (v.childList.length > 0) this.setInputFeeFn(v.childList)
        v.fee = v.fee ? v.fee : 20
        v.inputFee = v.fee
      })
      return navArr
    },
    getCompanyFee(navArr) {
      navArr.forEach(v => {
        var obj = {}
        obj.fee = v.inputFee
        obj.companyId = v.id
        this.feeArr.push(obj)
        if (v.childList.length > 0) this.getCompanyFee(v.childList)
      })
    },
    cancel() {
      this.isEdit = false
      this.navList = this.setInputFeeFn(this.navList)
    },
    changeFee(val) {
    },
    submit() {
      this.feeArr = []
      this.getCompanyFee(this.navList)
      // console.log('submit:this.feeArr', JSON.stringify(this.feeArr), this.feeArr)
      var bool = this.feeArr.every(v => { return (v.fee).toString().length })
      if (!bool) {
        this.$message({
          type: 'error',
          message: this.$t('sim.warnFee')// '费用不能为空，请重新输入'
        })
        return
      }
      this.$confirm(this.$t('basicinfo.submitChange'), '', {
        confirmButtonText: this.$t('button.Confirm'), // '确定',
        cancelButtonText: this.$t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        batchUpdateCompanyServiceFee(this.feeArr).then(res => {
          if (res.resultCode == 1001) {
            this.$message({
              type: 'success',
              message: this.$t('warningSet.submitted')
            })
            this.initCompanyList() // 获取左侧公司列表--初始化
          }
        })
      }).catch(() => { })
    }

  }
}
</script>

<style lang="scss" scoped>
.serviceIndex {
  height: 100%;
  .el-tree {
    background: #f0f2f5;
  }
  .leftBax {
    height: 100%;
    border-radius: 16px;
    padding: 30px 30px 20px;
    width: 70%;
    max-width: 1000px;
    overflow: auto;
    background: #fff;
  }
  .el-tree{
    margin: 20px 0 0;
    max-height: calc(100% - 60px);
    overflow: auto;
    padding-right: 10px;
    .labelItem img{
      width: 22px;
      vertical-align: sub;
    }
    .custom-tree-node{
      overflow: hidden;
      word-break: normal;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 0 70px 0 0;
    }
    .el-tree-node__content{
      position: relative;
      height: 35px;
      line-height: 35px;
    }
  }
  .titleP{
    margin-bottom: 30px;
    font-size: 14px;
  }
  .moreIconBox{
    position: absolute;
    right: 0;
    height: 60%;
    top: 20%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3;
    padding-left:30px;
    .warnP{
      color: red;
      font-size: 12px;
      position: absolute;
      right: calc(100% + 10px);
    }
  }
  .footBtn{
    text-align: center;
    width:100%;
  }
  .searchBox{
    display: flex;
    .el-input{
      max-width: 400px;
      margin-right: 20px;
    }
    // align-items: center;
    // justify-content: space-around;
  }
  .childListSize>div{
    display: inline-block;
    position: relative;
  }
}
</style>
